export enum NotificationType {
  POLICY_NOTE_MENTION = 'POLICY_NOTE_MENTION',
  POLICY_STATUS_CHANGE = 'POLICY_STATUS_CHANGE',
  POLICY_ASSIGNMENT = 'POLICY_ASSIGNMENT',
  POLICY_ASSIGNMENT_REQUEST = 'POLICY_ASSIGNMENT_REQUEST',
  POLICY_PAYMENT_VIEW = 'POLICY_PAYMENT_VIEW',
  COMMISSION_CLAIM = 'COMMISSION_CLAIM',
  COMMISSION_APPROVED = 'COMMISSION_APPROVED',
  COMMISSION_REJECTED = 'COMMISSION_REJECTED',
  POLICY_REMINDER = 'POLICY_REMINDER',
  LEAD_ASSIGNMENT = 'LEAD_ASSIGNMENT',
  TICKET_ASSIGNED = 'TICKET_ASSIGNED',
  TICKET_STATUS_CHANGE = 'TICKET_STATUS_CHANGE',
  TICKET_COMMENT = 'TICKET_COMMENT',
  SIGNATURE_COMPLETED = 'SIGNATURE_COMPLETED',
  SIGNATURE_PENDING = 'SIGNATURE_PENDING',
  CAMPAIGN_LAUNCH_REQUEST = 'CAMPAIGN_LAUNCH_REQUEST',
  VOICEMAIL = 'VOICEMAIL',
  GENERAL = 'GENERAL',
}

export enum NotificationPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

export interface INotificationUser {
  id: string
  firstName: string
  lastName: string
  email: string
}

export interface INotificationPolicy {
  id: string
  policyName: string
}

export interface INotificationLead {
  id: string
  name?: string
}

export interface INotification {
  id: string
  notificationType: NotificationType
  priority: NotificationPriority
  title: string
  message: string
  metadata: Record<string, any>
  actionUrl?: string
  isRead: boolean
  readAt?: string
  created: string
  createdBy?: INotificationUser
  policy?: INotificationPolicy
  lead?: INotificationLead
}

export interface IGetMyNotificationsResponse {
  allNotifications: {
    edges: Array<{
      node: INotification
    }>
    totalCount: number
  }
}

export interface IGetUnreadNotificationsCountResponse {
  unreadNotificationsCount: number
}

export interface INotificationTypeCount {
  notificationType: string
  unreadCount: number
}

export interface IGetUnreadNotificationsByTypeResponse {
  unreadNotificationsByType: INotificationTypeCount[]
}

export interface IGetNotificationTypesWithDataResponse {
  notificationTypesWithData: string[]
}

export interface IGetNotificationByIdResponse {
  notification: INotification
}

export interface IMarkNotificationAsReadResponse {
  markNotificationAsRead: {
    success: boolean
    errors?: Array<{ field?: string; message: string }>
    notification?: INotification
  }
}

export interface IMarkNotificationAsUnreadResponse {
  markNotificationAsUnread: {
    success: boolean
    errors?: Array<{ field?: string; message: string }>
    notification?: INotification
  }
}

export interface IMarkAllNotificationsAsReadResponse {
  markAllNotificationsAsRead: {
    success: boolean
    count: number
    errors?: Array<{ field?: string; message: string }>
  }
}

export interface IDeleteNotificationResponse {
  deleteNotification: {
    success: boolean
    errors?: Array<{ field?: string; message: string }>
  }
}

// Tipos de notificaciones de firma
export const SIGNATURE_NOTIFICATION_TYPES = [
  NotificationType.SIGNATURE_COMPLETED,
  NotificationType.SIGNATURE_PENDING,
]

// Tipos de notificaciones de leads
export const LEAD_NOTIFICATION_TYPES = [NotificationType.LEAD_ASSIGNMENT]

// Tipos de notificaciones generales (todo excepto firmas y leads)
export const GENERAL_NOTIFICATION_TYPES = [
  NotificationType.POLICY_NOTE_MENTION,
  NotificationType.POLICY_STATUS_CHANGE,
  NotificationType.POLICY_ASSIGNMENT,
  NotificationType.POLICY_ASSIGNMENT_REQUEST,
  NotificationType.POLICY_PAYMENT_VIEW,
  NotificationType.COMMISSION_CLAIM,
  NotificationType.COMMISSION_APPROVED,
  NotificationType.COMMISSION_REJECTED,
  NotificationType.POLICY_REMINDER,
  NotificationType.TICKET_ASSIGNED,
  NotificationType.TICKET_STATUS_CHANGE,
  NotificationType.TICKET_COMMENT,
  NotificationType.CAMPAIGN_LAUNCH_REQUEST,
  NotificationType.VOICEMAIL,
  NotificationType.GENERAL,
]
